// extracted by mini-css-extract-plugin
module.exports = {"flexwrap":"Table-styles-module--flexwrap--1Rft_","currency":"Table-styles-module--currency--3VlTs"};